import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	padding: 10px 14px;
	background-color: ${({ theme }) => `${theme.blue[500]}14`};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 6px;
	margin-bottom: 2px;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Title = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	line-height: 1.4;
`;

export const CloseButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	background: none;
	border: none;
	color: ${({ theme }) => theme.gray[400]};
	border-radius: 4px;
	flex-shrink: 0;
	transition: all 0.15s ease;

	&:hover {
		color: ${({ theme }) => theme.gray[700]};
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

export const ActionLink = styled.button`
	background: none;
	border: none;
	padding: 0;
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.blue[600]};
	text-decoration: underline;
	text-underline-offset: 2px;
	white-space: nowrap;
	transition: color 0.15s ease;
	margin-bottom: 2px;

	&:hover {
		color: ${({ theme }) => theme.blue[800]};
	}
`;
